import React from "react";
import cardIcon from "../assets/svgs/card-icon.svg";
import nftSquare from "../assets/svgs/nft-square.svg";
import linkIcon from "../assets/svgs/link-icon.svg";
import discordIcon from "../assets/svgs/DiscordIcon.svg";
import { EnvelopeIcon } from "@heroicons/react/24/solid";

import socialIcon from "../assets/svgs/Social.svg";

function Middle() {
    return (
      <div className="vstack gap-[32px] 2xl:grid 2xl:grid-cols-2 2xl:mt-[3%] 2xl:gap-[63px]">
        <div className="basis-1/2 2xl:h-[129px] ">
          <img src={cardIcon} width="34" height="34" alt="cardicon" />
          <h3 className="text-xl font-bold pt-4">Claim and collect</h3>
          <p className="text-subtleText">
            Claim your valuable collectible as a digital twin NFT and start
            collecting.
          </p>
        </div>
        <div className="basis-1/2 2xl:h-[129px]">
          <img src={nftSquare} width="34" height="34" alt="nftSquare" />
          <h3 className="text-xl font-bold pt-4">Safe and secure</h3>
          <p className="text-subtleText">
            Collect, claim, mint and trade your valuable
            phygital collectibles safe and secure worldwide.
          </p>
        </div>
        <div className="basis-1/2 2xl:h-[129px]">
          <img src={linkIcon} width="34" height="34" alt="linkIcon" />
          <h3 className="text-xl font-bold pt-4">Mint and trade</h3>
          <p className="text-subtleText">
            Trade your digital twin NFTs worldwide on our secure international
            marketplace (available soon).
          </p>
        </div>
        <div className="basis-1/2 2xl:h-[129px]">
          <img src={socialIcon} width="34" height="34" alt="socialIcon" />
          <h3 className="text-xl font-bold pt-4">Community</h3>
          <p className="text-subtleText">
            Join our Discord community to connect with other collectors
            worldwide. Or, simply send us an email. We’re here to help!
          </p>
          <div className="flex items-center w-full space-x-5 2xl:space-x-3 pt-2">
            <a
              href="https://discord.gg/X69zQm4kWk"
              target="_blank"
              rel="noreferrer"
            >
              <img src={discordIcon} className="h-8 w-8" alt="discordIcon" />
            </a>
            <a href="mailto:contact@ciphers.me">
              <EnvelopeIcon className="h-8 w-8 text-primary" />
            </a>
          </div>
        </div>
      </div>
    );
}

export default Middle;
